<template>

  <div>      

    <div class="dashboard">
       <div class="sr-ui-container wrap">
        <div class="sr-ui-container-header">控制台</div>
        <div class="sr-ui-container-body"> 

              <el-tabs v-model="activeName"    @tab-click="handleTabClick">
                  <el-tab-pane v-for="(item,index,row ) in tabList"  :label="item.title"  :name="'t'+item.id" > </el-tab-pane> 
              </el-tabs>

       
              <div  v-if="activeName == 't0' " >
                <div   class="table-top">

                  <div v-if="roomCurDate['today']" class="table-top-left">
                    <div class="table-today">{{roomCurDate["today"]}}</div>
                    <div class="table-weekday">周{{roomCurDate["weekday"]}} ({{roomCurDate["weekRange"]["monday"]}}-{{roomCurDate["weekRange"]["sunday"]}})</div>
                    <div style="display:flex;padding:0px 20px ;height:40px;     align-items: flex-end;">
                        <div style="display:flex;"><div class="content_status_1" style="width:20px;height:20px;margin:0px 10px;"></div>定金</div>
                        <div style="display:flex;"><div class="content_status_2" style="width:20px;height:20px;margin:0px 10px;"></div>预订</div>
                        <div style="display:flex;"><div class="content_status_3" style="width:20px;height:20px;margin:0px 10px;"></div>确定</div>
                        <div style="display:flex;"><div class="content_status_4" style="width:20px;height:20px;margin:0px 10px;"></div>预留</div>
                        
                        <el-button @click="goToPC" type="primary"  style="margin:0px 10px; " size="small" plain>打开电脑紧凑版本</el-button> 

                        <el-popover
                          placement="right"
                          width="200"
                          trigger="click">
                             <img src="../assets/images/e.png" width="200">
                          <el-button type="primary"  slot="reference" style="margin:0px 10px; " size="small" plain>获取手机二维码</el-button>
                        </el-popover>

            
                    </div>

                  </div>

                  <div class="table-top-right">
                      <el-button type="primary" size="mini" icon="el-icon-arrow-left"  @click="timeFrameSelect(1)"></el-button>

                        <el-date-picker
                            @change="handleChangePicker"
                            v-model="roomDateRangeValue"
                            style=" width:260px;margin:0px 5px;"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-M-d" 
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>

                        <el-button size="mini"  type="primary"    @click="timeFrameSelect(2)"><i class="el-icon-arrow-right el-icon--right"></i></el-button>

                  </div>

                </div>

                <div  class="table-middle">

                  <el-tabs v-model="storeSN"  type="card"    @tab-click="handleStoresClick">
                    <el-tab-pane  v-for="(item,index,key) in storesData"  :label="item.title"  :name="item.sn"></el-tab-pane>
                  </el-tabs>

                </div>

            	  <div  class="table-container">

                    <div class="table-coninner" :style="'width:'+tableContainerWith+'px;'">
                      <div class="dashboard_tr_1"> 
                         <div class="dashboard_td_1_1"><div class="dashboard_td_1_title"></div> </div>
                          <div v-for=" (item,index,key) in roomData['dateRange']"  class="dashboard_td"><div class=" dashboard_content_title">{{item.date}}{{item.weekday}}</div></div>
                      </div>

                      <div>
  
                        <div class="dashboard_tr" v-for="(item,index,key) in roomData['rooms']"> 

                          <div class="dashboard_td_1_1">
                            <div class="dashboard_td_1_title"> {{item.room_number}}</div>
                          </div>

                          <div v-for=" (item2,index,key) in item['dateRange']"  class="dashboard_td">

                              <div class="dashboard_content_box">
                                
                                  <div v-for=" (item3,index,key) in item2['dateArry']">

                                        <div v-if="!item3['order']"  class="dashboard_content content_status_0">

                                            <div class="dashboard_line">
                                              <div class="dashboard_left">
                                                <div class="dashboard_name">无</div>
                                                <div class="dashboard_num"></div>
                                              </div>
                                                <div   class="dashboard_status status_color_0">未使用</div>
                                            </div> 

                                              <div class="dashboard_line" v-if="false">
                                                  <div class="dashboard_time">{{item3["name"]}}</div> 
                                                  <div class="dashboard_right"></div>
                                              </div> 

                                        </div>

                                        <!--定金-->
                                        <div @click="getOrderDetai(item3['order']['sn'])"  v-if="item3['order'] && item3['order']['contracts'] && item3['order']['contracts']['receivables']>0"   class="dashboard_content content_status_1">
                                            <div class="dashboard_line">

                                                <div class="dashboard_left">
                                                  <div class="dashboard_name">
                                                      <div class="dashboard_name_left">{{item3['order']['customer_name']}}</div>
                                                      <div class="dashboard_name_middel" v-if="item3['order']['number_people']" >{{item3['order']['number_people']}}人</div>
                                                    </div>
                                                    <div class="dashboard_num" v-if="item3['order']['start_time'] !='null'">{{item3['order']['start_time']}}</div>
                                                </div>

                                                <div  v-if="false" class="dashboard_status status_color_1">
                                                  <span>定金</span>
                                                </div>

                                            </div> 

                                            
                                            <div class="dashboard_line" v-if="false">
                                                <div class="dashboard_time">{{item3["name"]}}</div> 
                                                <div class="dashboard_right">
                                                      <div class="dashboard_order_status"></div>
                                                      <div v-if=" item3['order'] && item3['order']['amount']>0" class="dashboard_price">￥<span>{{item3["order"]["amount"]}}</span></div>
                                                </div>
                                            </div> 

                                        </div>


                                         <!--确定-->
                                        <div @click="getOrderDetai(item3['order']['sn'])"  v-if="item3['order'] && item3['order']['contracts'] && item3['order']['contracts']['receivables'] <= 0"   class="dashboard_content content_status_3">
                                            <div class="dashboard_line">

                                                <div class="dashboard_left">
                                                  <div class="dashboard_name">
                                                      <div class="dashboard_name_left">{{item3['order']['customer_name']}}</div>
                                                      <div class="dashboard_name_middel" v-if="item3['order']['number_people']">{{item3['order']['number_people']}}人</div>
                                                    </div>
                                                    <div class="dashboard_num" v-if="item3['order']['start_time'] !='null'">{{item3['order']['start_time']}}</div>
                                                </div>

                                                <div v-if="false" class="dashboard_status status_color_1">
                                                  <span>确定</span>
                                                </div>

                                            </div> 

                                            
                                            <div class="dashboard_line" v-if="false">
                                                <div class="dashboard_time">{{item3["name"]}}</div> 
                                                <div class="dashboard_right">
                                                      <div class="dashboard_order_status"></div>
                                                      <div v-if=" item3['order'] && item3['order']['amount']>0" class="dashboard_price">￥<span>{{item3["order"]["amount"]}}</span></div>
                                                </div>
                                            </div> 

                                        </div>

                                        <!--预留-->
                                        <div @click="getOrderDetai(item3['order']['sn'])"  v-if="item3['order'] && (!item3['order']['contracts']) && item3['order']['amount']==0"   class="dashboard_content content_status_4">
                                            <div class="dashboard_line">

                                                <div class="dashboard_left">
                                                  <div class="dashboard_name">
                                                      <div class="dashboard_name_left">{{item3['order']['customer_name']}}</div>
                                                      <div class="dashboard_name_middel" v-if="item3['order']['number_people']">{{item3['order']['number_people']}}人</div>
                                                    </div>
                                                    <div class="dashboard_num" v-if="item3['order']['start_time'] !='null'">{{item3['order']['start_time']}}</div>
                                                </div>

                                                <div  v-if="false" class="dashboard_status status_color_1">
                                                  <span>预留</span>
                                                </div>

                                            </div> 

                                            
                                            <div class="dashboard_line" v-if="false">
                                                <div class="dashboard_time">{{item3["name"]}}</div> 
                                                <div class="dashboard_right">
                                                      <div class="dashboard_order_status"></div>
                                                      <div v-if=" item3['order'] && item3['order']['amount']>0" class="dashboard_price">￥<span>{{item3["order"]["amount"]}}</span></div>
                                                </div>
                                            </div> 

                                        </div>


                                        <!--预订-->
                                        <div @click="getOrderDetai(item3['order']['sn'])"  v-if="item3['order'] && (!item3['order']['contracts']) && item3['order']['amount']>0"   class="dashboard_content content_status_2">
                                            <div class="dashboard_line">

                                                <div class="dashboard_left">
                                                  <div class="dashboard_name">
                                                      <div class="dashboard_name_left">{{item3['order']['customer_name']}}</div>
                                                      <div class="dashboard_name_middel" v-if="item3['order']['number_people']">{{item3['order']['number_people']}}人</div>
                                                    </div>
                                                    <div class="dashboard_num" v-if="item3['order']['start_time'] !='null'">{{item3['order']['start_time']}}</div>
                                                </div>

                                                <div  v-if="false" class="dashboard_status status_color_1">
                                                  <span>预订</span>
                                                </div>

                                            </div> 

                                            
                                            <div class="dashboard_line" v-if="false">
                                                <div class="dashboard_time">{{item3["name"]}}</div> 
                                                <div class="dashboard_right">
                                                      <div class="dashboard_order_status"></div>
                                                      <div v-if=" item3['order'] && item3['order']['amount']>0" class="dashboard_price">￥<span>{{item3["order"]["amount"]}}</span></div>
                                                </div>
                                            </div> 

                                        </div>


                                  </div>

                              </div>

                          </div>

                        </div>

                      </div>
                    </div>
                   
                </div>
                
              </div>


              <div  v-if="activeName=='t1' || activeName=='t2' " >

                <div class="dashboard-body-wrap" >
                  <div id="container"></div>
                  <el-row :gutter="12" style="margin-bottom:10px;">
                        <el-col :span="24">
                          
                            <el-select v-model="teamValue" placeholder="请选择" @change="checkTeam()"  v-if="activeName=='t2'" >
                              <el-option
                                v-for="item in teamOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                :disabled="item.disabled">
                              </el-option>
                            </el-select>

                            <el-select v-model="ourTeamValue" v-if="teamValue==5" placeholder="请选择" @change="getData(0)">
                              <el-option
                                v-for="item in ourTeam" 
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                >
                              </el-option>
                            </el-select>

                            <el-select v-model="joinTypeValue"   v-if="teamValue==5"  placeholder="请选择" @change="getData(0)">
                              <el-option
                                v-for="item in joinType"  
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                >
                              </el-option>
                            </el-select>

                            <el-cascader  v-model="dateValue" :options="dateOptions" :show-all-levels="false" @change="checkType()"></el-cascader>
                            <el-date-picker @change="getData(1)"
                                v-if="daterange"
                                value-format="yyyy-M-d" 
                                v-model="daterangeValue"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                            </el-date-picker>

                            
                            <el-select v-model="projectValue" v-if="projectData.length>0" placeholder="请选择" @change="getData(0)">
                              <el-option
                                v-for="item in projectData" 
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                >
                              </el-option>
                            </el-select>

                            

                        </el-col>
                  </el-row>

                  <el-card shadow="never">
                      <el-descriptions>
                          <span slot="title" class="dashboardTitle"><i class="el-icon-data-analysis dashboardIcon"></i>数据简报</span>
                      </el-descriptions>
                      
                      <el-row :gutter="12">
                        <el-col :span="6" v-for="item in statisticsArray1" >
                          <el-card shadow="hover" class="marginTop5" >
                            <div class="infoItem" style="cursor: pointer">
                              <div class="title infoItem_box"> {{item.name}}  <el-link v-if="item.id" type="primary" @click="exportData(item.id)">导出报表</el-link></div>
                              <div class="info"><span class="normal" style="font-size:16px;">{{item.num}}</span><em>{{item.unit}}</em></div>
                              <div style="color:#aaa;font-size:11px;font-style:italic">{{item.des}}</div>
                            </div>
                          </el-card>
                        </el-col>
                      </el-row>

                  </el-card>

                  <div id="container"></div>

                     <el-row :gutter="12">
                      
                       <el-col :span="element.span"  v-for="element in myArray01" :key="element.id" >

                         <div class="marginTop20">
                                  <el-card shadow="never">

                                    <el-descriptions >
                                        <div slot="title" class="dashboardTitle dashboardTitle2">
                                            <span><i class="el-icon-s-grid dashboardIcon2"></i>{{element.name}}</span>
                                            <span class="exportTitle"><el-link v-if="false" type="primary" @click="exportData(element.id)" >导出数据</el-link></span>
                                        </div>
                                    
                                    </el-descriptions>

                                    <div :id="element.id"></div>

                                    <div v-if="element.type=='table1'">
      
                                        <el-tabs v-model="table1_tabs" type="card" @tab-click="handleTable1TabsClick"> 
                                            <el-tab-pane label="全部" name="1"></el-tab-pane>
                                            <el-tab-pane label="未完成" name="2"></el-tab-pane>
                                            <el-tab-pane label="已完成" name="3"></el-tab-pane>
                                        </el-tabs>
                                
                                      <el-table
                                          :data="element.data"
                                          style="width: 100%">
                                          <el-table-column prop="name"    label="姓名" ></el-table-column>
                                          <el-table-column prop="value1_f"  label="完成"  ></el-table-column>
                                          <el-table-column prop="value2_f"  label="目标" ></el-table-column>
                                          <el-table-column prop="value3"  label="百分比"  >
                                            <template slot-scope="scope"> 
                                                <el-progress type="circle" :percentage="scope.row.value3" :width="progress_width"></el-progress>
                                            </template>
                                          
                                          </el-table-column>
                                      </el-table>

                                    </div>

                                    <div  v-if="element.type=='table2'">
                                      <el-table
                                          :data="element.data"
                                          style="width: 100%">
                                          <el-table-column prop="name"    label="姓名" ></el-table-column>
                                          <el-table-column prop="value1"  label="总数"  ></el-table-column>
                                          <el-table-column prop="value2"  label="沟通报价"  ></el-table-column>
                                          <el-table-column prop="value3"  label="合同预订"  ></el-table-column>
                                          <el-table-column prop="value4"  label="签约付款"  ></el-table-column>
                                          <el-table-column prop="value5"  label="失单"  ></el-table-column>
                                      </el-table>
                                    </div>

                                  </el-card>
                          </div>

                       </el-col>
                 
                     </el-row>

                    <el-row :gutter="12" v-if="false">
                      <el-col :span="24">
                              <div class="marginTop20" v-for="element in myArray01" :key="element.id">
                                  <el-card shadow="never">

                                    <el-descriptions >
                                        <div slot="title" class="dashboardTitle dashboardTitle2">
                                            <span><i class="el-icon-s-grid dashboardIcon2"></i>{{element.name}}</span>
                                            <span class="exportTitle"><el-link v-if="false" type="primary" @click="exportData(element.id)" >导出数据</el-link></span>
                                        </div>
                                    
                                    </el-descriptions>

                                    <div :id="element.id"></div>

                                    <div v-if="element.type=='table1'">
      
                                        <el-tabs v-model="table1_tabs" type="card" @tab-click="handleTable1TabsClick"> 
                                            <el-tab-pane label="全部" name="1"></el-tab-pane>
                                            <el-tab-pane label="未完成" name="2"></el-tab-pane>
                                            <el-tab-pane label="已完成" name="3"></el-tab-pane>
                                        </el-tabs>
                                
                                      <el-table
                                          :data="element.data"
                                          style="width: 100%">
                                          <el-table-column prop="name"    label="姓名" ></el-table-column>
                                          <el-table-column prop="value1_f"  label="目标"  ></el-table-column>
                                          <el-table-column prop="value2_f"  label="完成" ></el-table-column>
                                          <el-table-column prop="value3"  label="百分比"  >
                                            <template slot-scope="scope"> 
                                                <el-progress type="circle" :percentage="scope.row.value3" :width="progress_width"></el-progress>
                                            </template>
                                          
                                          </el-table-column>
                                      </el-table>

                                    </div>

                                    <div  v-if="element.type=='table2'">
                                      <el-table
                                          :data="element.data"
                                          style="width: 100%">
                                          <el-table-column prop="name"    label="姓名" ></el-table-column>
                                          <el-table-column prop="value1"  label="总数"  ></el-table-column>
                                          <el-table-column prop="value2"  label="沟通报价"  ></el-table-column>
                                          <el-table-column prop="value3"  label="合同预订"  ></el-table-column>
                                          <el-table-column prop="value4"  label="签约付款"  ></el-table-column>
                                          <el-table-column prop="value5"  label="失单"  ></el-table-column>
                                      </el-table>
                                    </div>

                                  </el-card>
                              </div>
                      </el-col>
                    </el-row>

                    <el-row :gutter="12">
                      <el-col :span="12">
                        <draggable v-model="myArray1"  chosenClass="chosen" forceFallback="true" :group="groupA" animation="10" @start="onStart" @end="onEnd">
                            <transition-group>
                              <div class="marginTop20" v-for="element in myArray1" :key="element.id">
                                  <el-card shadow="never">
                                    <el-descriptions>
                                      <span slot="title" class="dashboardTitle"><i class="el-icon-s-grid dashboardIcon2"></i>{{element.name}}</span>
                                    </el-descriptions>
                                    <div :id="element.id"></div>
                                    <div v-if="element.type=='table_temp1'">

                                      <el-table
                                          :data="element.data"
                                          style="width: 100%">
                                          <el-table-column prop="name" label="姓名" ></el-table-column>

                                      </el-table>

                                    </div>
                                  </el-card>
                              </div>
                            </transition-group>
                        </draggable> 
                      </el-col>

                      <el-col :span="12">
                        <draggable v-model="myArray2"  chosenClass="chosen" forceFallback="true" :group="groupB" animation="10" @start="onStart" @end="onEnd">
                            <transition-group>
                              <div  class="marginTop20" v-for="element in myArray2" :key="element.id">
                                  <el-card shadow="never" >
                                    <el-descriptions>
                                      <span slot="title" class="dashboardTitle"><i class="el-icon-s-grid dashboardIcon2"></i>{{element.name}}</span>
                                    </el-descriptions>
                                    <div :id="element.id"></div>
                                    <div v-if="element.type=='table'">
                                      <el-table
                                          :data="element.data"
                                          style="width: 100%">
                                          <el-table-column prop="type" label="姓名" width="180"></el-table-column> 
                                          <el-table-column prop="sales"  label="项目数量" width="180"  ></el-table-column>
                                        </el-table>
                                    </div>
                                  </el-card>
                              </div>
                            </transition-group>
                        </draggable> 
                      </el-col>
        
                    </el-row>

                </div>
                
              </div>
              

              <div  v-if="activeName=='t3' || activeName=='t4'"  >

                  <div style="padding:20px 0px;"> 

                        <el-select v-model="searchCalculate.city_sn" filterable placeholder="请选择" @change="searchCalculateTotal(0)">
                            <el-option
                              v-for="item in cityListData"
                              :key="item.sn"
                              :label="item.name"
                              :value="item.sn">
                            </el-option>
                        </el-select>

                        <el-select v-model="searchCalculate.store_sn" filterable placeholder="请选择" @change="searchCalculateTotal(1)">
                            <el-option
                              v-for="item in storeListData"
                              :key="item.sn"
                              :label="item.name"
                              :value="item.sn">
                            </el-option>
                        </el-select>
                     
                        <el-select v-model="searchCalculate.room_sn" filterable placeholder="请选择" @change="searchCalculateTotal(2)">
                            <el-option
                              v-for="item in roomListData"
                              :key="item.sn"
                              :label="item.name"
                              :value="item.sn">
                            </el-option>
                        </el-select>

                        <el-date-picker @change="searchCalculateTotal(3)"
                                value-format="yyyy-M-d" 
                                v-model="searchCalculate.daterangeValue"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>

                        <el-button @click="handleFinanceExport" type="primary"  style="margin:0px 10px; " size="small" plain>下载财务数据报表</el-button> 

                  </div>
                
                   <div style="padding:20px 20px 10px 10px;"><h2>会议室预订率明细表</h2></div>
                    <div style="padding:20px; background-color:#fff;">
                        <el-descriptions>
                          <el-descriptions-item label="使用会议格总数">{{calculateTotalData["sum1"]}}</el-descriptions-item>
                          <el-descriptions-item label="当期可预定会议格总数">{{calculateTotalData["sum2"]}}</el-descriptions-item>
                          <el-descriptions-item label="预定率">{{calculateTotalData["sum3"]}}</el-descriptions-item>
                        </el-descriptions>
                    </div>

                    <div style="padding:20px 20px 10px 10px;"><h2>城市预定率</h2></div>
                    <div style="padding:20px;background-color:#fff;">
                      <el-table :data='calculateTotalData["city_list"]' style="width: 100%"  border>
                        <el-table-column prop="city_name" label="名称" ></el-table-column>
                        <el-table-column prop="sum1" label="使用" ></el-table-column>
                        <el-table-column prop="sum2" label="总数" ></el-table-column>
                        <el-table-column prop="sum3" label="预定率" ></el-table-column>
                      </el-table>
                    </div>

                    
                    <div style="padding:20px 20px 10px 10px;"><h2>门店预定率</h2></div>
                    <div style="padding:20px;background-color:#fff;">
                      <el-table :data='calculateTotalData["stores"]' style="width: 100%" border>
                        <el-table-column prop="name" label="名称" ></el-table-column>
                        <el-table-column prop="sum1" label="使用" ></el-table-column>
                        <el-table-column prop="sum2" label="总数" ></el-table-column>
                        <el-table-column prop="sum3" label="预定率" ></el-table-column>
                      </el-table>
                    </div>



                    <div style="padding:20px 20px 10px 10px;"><h2>会议室预定率</h2></div>
                    <div style="padding:20px;background-color:#fff;">
                      <el-table :data='calculateTotalData["meeting_rooms"]' style="width: 100%" :max-height="500" border>
                        <el-table-column prop="city_name" label="城市" ></el-table-column>
                        <el-table-column prop="stores_name" label="门店" ></el-table-column>
                        <el-table-column prop="name" label="会议室" ></el-table-column>
                        <el-table-column prop="room_number" label="会议室号" ></el-table-column>
                        <el-table-column prop="sum1" label="使用" ></el-table-column>
                        <el-table-column prop="sum2" label="总数" ></el-table-column>
                        <el-table-column prop="sum3" label="预定率" ></el-table-column>
                      </el-table>
                    </div>

                      <div  v-if="false"  style="padding:20px 20px 10px 10px;"><h2>合同总表</h2></div>
                      <div  v-if="false"  style="padding:20px;background-color:#fff;">

                      <el-table :data='calculateTotalData["order_list"]' style="width: 100%" :max-height="500" border v-if="false">
                        <el-table-column prop="customer_name" label="客户名称" ></el-table-column>
                        <el-table-column prop="stores_name" label="门店" ></el-table-column>
                        <el-table-column prop="meeting_room_name" label="会议室" ></el-table-column>
                        <el-table-column prop="meeting_room_room_number" label="会议室号" ></el-table-column>
                        
                        <el-table-column prop="contracts_name" label="合同名称" ></el-table-column>
                        <el-table-column prop="contracts_serial_number" label="合同单号" ></el-table-column>

                        <el-table-column prop="contracts_amount" label="合同金额" ></el-table-column>
                        <el-table-column prop="contracts_payment_amount" label="支付金额" ></el-table-column>
                        <el-table-column prop="contracts_payment_receivables" label="待支付" ></el-table-column>

                        <el-table-column prop="staffs_name" label="销售人员" ></el-table-column>
                        

                      </el-table>

                    </div>


              </div>


        </div>
       </div>
    </div>


    <el-dialog
      title="订单详情"
      :visible.sync="dialogOrderVisible"
      width="1400px"
      :before-close="handleOrderClose">

        
          <el-descriptions title="基础信息" :column="2"  border >


            <el-descriptions-item>
              <template slot="label">
                  <i class="el-icon-user"></i>
                  客户
                </template>
                {{orderDetailData["customer_text"]}}
            </el-descriptions-item>

            <el-descriptions-item>
              <template slot="label">
                <i class="el-icon-user"></i>
                 销售人员
              </template>
              {{orderDetailData["staff_text"]}}
            </el-descriptions-item>

            <el-descriptions-item>
              <template slot="label">
                会议室号
              </template>
              {{orderDetailData["rooms_text"]}}
            </el-descriptions-item>

            <el-descriptions-item>
              <template slot="label">
                日期
              </template>
              {{orderDetailData["on_site_time"]}}
            </el-descriptions-item>
            
            <el-descriptions-item>
              <template slot="label">
                 时间类型
              </template>
              {{orderDetailData["time_type_text"]}}
            </el-descriptions-item>


            <el-descriptions-item>
              <template slot="label">
                时段
              </template>
              {{orderDetailData["start_time"]}}
            </el-descriptions-item>

   
    


  
            <el-descriptions-item :span="2">
              <template slot="label" >
                人数
              </template>
              {{orderDetailData["number_people"]}}
            </el-descriptions-item>



            <el-descriptions-item v-if='orderDetailData["amount"]'>
              <template slot="label">
                销售金额
              </template>
              {{orderDetailData["amount"]}}
            </el-descriptions-item>
    

            <el-descriptions-item v-if='orderDetailData["discount"]'>
              <template slot="label">
                销售折扣
              </template>
              {{orderDetailData["discount"]}}
            </el-descriptions-item>



            <el-descriptions-item :span="2">
              <template slot="label" >
                备注
              </template>
              {{orderDetailData["remark"]}}
            </el-descriptions-item>

            

            <el-descriptions-item :span="2">
              <template slot="label">
                桌型
              </template>
              {{orderDetailData["table_types"]}}
            </el-descriptions-item>

       

            <el-descriptions-item :span="2">
              <template slot="label">
                设备配套
              </template>
              {{orderDetailData["option_service"]}}
            </el-descriptions-item>


            
            
         
          </el-descriptions>

         <div class="order_title">常用联系人信息</div> 

           <el-table :data="orderDetailData['contact']" style="width: 100%">
              <el-table-column  prop="name" label="姓名" width="150"></el-table-column>
              <el-table-column  prop="phone" label="手机" ></el-table-column>
              <el-table-column  prop="wx" label="微信" ></el-table-column>
           </el-table>


        
          <div class="order_title">增值业务</div>
        
            <el-table
                      :data="orderDetailData['added_services']"
                      style="width: 100%"
                    >
                        <el-table-column  prop="on_date" label="时间" width="150"></el-table-column>
                        <el-table-column  prop="value_added_services_name" label="类型" ></el-table-column>
                        <el-table-column  prop="value_added_services_goods_name" label="名称" ></el-table-column>
                        <el-table-column  prop="quantity" label="数量" width="100" ></el-table-column>
            </el-table>


    </el-dialog>

   <el-dialog
      title="导出财务报表"
      :visible.sync="isShowFinanceExport"
      width="600px"
      :before-close="handleFinanceExportClose">
    
         <el-date-picker
                value-format="yyyy-M-d" 
                v-model="financeExportDaterangeValue"
                 type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                 end-placeholder="结束日期">
         </el-date-picker>

         <div style="margin-top:30px;">
             <el-button @click="handleFinanceOrderExport" type="primary"  style="margin:0px 10px; " size="small" plain>下载订单数据报表</el-button> 
         </div>

         <div style="margin-top:20px;">
          <el-button @click="handleFinanceContractsExport" type="primary"  style="margin:0px 10px; " size="small" plain>下载合同数据报表</el-button> 
         </div>

      
    

   </el-dialog>


  </div>

</template>


<style scoped>


.el-table {
  height: auto !important;
}
/* 可选：让每一行的高度也根据内容自适应 */
.el-table__body .el-table__row {
  height: auto;
}

.order_title{
  padding:20px 0px;
  font-size:16px;
  font-weight:bold;
}

.dashboard_tr{
  display:flex;
}
.dashboard_tr_1{
  display:flex;
  position: sticky;
  top: 0;
  background:#fff;
}

.dashboard_td{
  font-size:14px;
  font-weight:bold;
  text-align: center;
  border-bottom: 1px solid #ccc;
  padding:5px 5px 5px 5px;

 
}
.dashboard_td_1{

  border-bottom: 1px solid #f1f1f1;
}
.dashboard_td_1_1{
   display: flex;
   flex-wrap: wrap;

  border-bottom: 1px solid #f1f1f1;
  background: #fff;
  position: sticky;
  left: 0;
  
}

.dashboard_td_1_title{
  display: flex;
  flex-wrap: wrap;
  width:100px;
  align-items: center;
  justify-content: center;
  font-size:18px;
  font-weight:bold;

}


.table-top{
  display: flex;
  justify-content: space-between;
  padding:10px 20px;
}
.table-middle{
  width:100%;
  background-color:#fff;
  padding:2px 0px 0px 2px;
}
.table-top-left{
   display: flex;
   justify-content: space-between;
   align-items: flex-end;
}
.table-top-right{
   display: flex;
   justify-content: space-between;
   height:38px;
  
}

.table-today{
  font-size:22px;
  font-weight:bold;
}

.table-weekday{
  margin-left:10px;
  font-size:14px;
}

.table-container{
    display: flex;
    flex-direction: column;
    position: relative;
    min-width: 100%;
    height:calc(100vh - 300px);
    background-color:#ffffff;
    overflow: auto;
  }
  .table-container_iner2{
      
  }

  .table-container_inner{
    width: 100%;
    height:calc(100vh - 340px);
    background-color:#ffffff;
    overflow: auto;
  }
  .dashboard_title{
    display: flex;
    justify-content: center;
    align-items: center;
    width:100%;
    height:50px;
    font-size:14px;
    border-right:1px solid #aaa;
    border-bottom:1px solid #aaa;
  }
  .dashboard_content_title{
    width:130px;
    padding:10px 10px;
    font-weight: bold;
    background: #fff;
  }
  .dashboard_content_box{
    width:130px;
    padding:5px 10px;
    border-right:1px solid #aaa;


  }
  .dashboard_content{
    padding:5px 10px;
     width:110px;
    height:50px;
    font-size:12px;
    margin-top:2px;
    border-radius: 20px;
  }

  .dashboard_name{
    display:flex;
    justify-content: space-between;
  }
  .dashboard_name_left{
    width:70px;
    height:20px;
    line-height: 20px;
    overflow: hidden;
  }
  .dashboard_name_middel{
    width:50px;
    overflow: hidden;
  }
  .dashboard_num{
    padding:0px 0px 0px 0px;
  }
  .dashboard_time{
    width:50%;
  } 

  .dashboard_price{


  }
  .dashboard_order_status{

  }

  .dashboard_order_status_color_1{

  }

  .dashboard_order_status_color_2{

  }

  .dashboard_order_status_color_2{

  }



  .dashboard_line{
    display: flex;
    flex-direction: row;
    width:100%;
    justify-content: space-between;
    padding:10px 0px;

  }

  .dashboard_left{
    
  }

  .dashboard_right{
    display: flex;

     width:50%;
    justify-content:space-between;
    
  }

  .dashboard_status{

    padding:5px 0px;
    width:50px;
    height:20px;
    font-size:12px;
    font-weight:bold;
    border-radius: 10px;
    text-align: center;
  }


  .content_status_0{
    background-color:#f1f1f1;
  }
  .status_color_0{
    background-color:#e9e9e9;
    color:#a8a8a8;
  }


            

  .content_status_1{
    background-color:#409EFF;
  }

  .status_color_1{

    color:#fff;
  }
    

  .content_status_2{
    background-color:#E6A23C;
  }
  .status_color_2{
    color:#fff;
  }


  .content_status_3{
    background-color:#67C23A;
  }

  .status_color_3{
    color:#fff;
  }

  .content_status_4{
    background-color:#F56C6C;
  }

  .status_color_4{
    color:#fff;
  }

  .content_status_5{
    background-color:#FFF7F5;
  }

  .status_color_5{
    background-color:#FFECE8;
    color:#F76C6B;
  }

  .content_status_6{
    background-color:#CBF3E3;
  }

  .status_color_6{
    background-color:#1F8B4D;
    color:#FFFFFF;
  }

  .infoItem_box{
      display: flex;
      justify-content: space-between;
  }








</style>
<script>

import {getExportTarget,getExportRoomOrder,getExportContracts,ourTeam,getConfigStatistics,getStatistics,getRooms,getStores,getRoomDate,getOrderDetailData,getCalculateTotalData,getStores2Data,getRooms2Data} from "../api/api.js";

import Header from "../components/header.vue";
import { insertCss } from 'insert-css';
import draggable from 'vuedraggable';
import { Bar,Funnel,Pie,Line,Column,chart} from '@antv/g2plot';


export default { 
  name: "Dashboard",
   components: {
      draggable,
  },
   data() {
    return { 
      username: localStorage.name,
      loading:false,
      drag:false,
      groupA:{
        name:'site',
        pull:true, //可以拖从
        put:true//可以拖出
      },

      groupB:{
        name:'site',
        pull:true,
        put:true
      },
      teamValue: '1',
      teamOptions: [
        {
          value: '1',
          label: '本人及下属'
        },{
          value: '2',
          label: '本人'
        }, {
          value: '3',
          label: '仅本部门'
        }, {
          value: '5',
          label: '自定义'
        }
      ],
      ourTeamValue:null,
      ourTeam:[],
      dateValue:['3','30'],
      dateOptions:[
        {
          value: '1',
          label: '天',
          children: [
            {
              value: '10',
              label: '今天',
            },
            {
              value: '11',
              label: '昨天',
            }
          ]
        },
        {
          value: '2',
          label: '周',
          children: [
            {
              value: '20',
              label: '本周',
            },
            {
              value: '21',
              label: '上周',
            }
          ]
        },
        {
          value: '3',
          label: '月',
          children: [
            {
              value: '30',
              label: '本月',
            },
            {
              value: '31',
              label: '上月',
            }
          ]
        },
        {
          value: '4',
          label: '季度',
          children: [
            {
              value: '40',
              label: '本季度',
            },
            {
              value: '41',
              label: '上一季度',
            }
          ]
        },
        {
          value: '5',
          label: '年度',
          children: [
            {
              value: '50',
              label: '本年度',
            },
            {
              value: '51',
              label: '上一年度',
            }
          ]
        },
        {
          value: '6',
          label: '自定义'
        },
       ],
      daterangeValue:[],
      daterange:false,

      myArray1:[],
      myArray2:[],
      myArray01:[],
      statisticsArray1:[],

      joinTypeValue:"2",
      joinType:[
        {
          value: '1',
          label: '参与'
        },
        {
          value: '2',
          label: '负责人'
        },
        {
          value: '3',
          label: '协助'
        }
      ],
      projectValue:null,
      projectData:[],

      storeSN:"",
      activeName:"t0",
      storesData:[],
      roomCurDate:[],
      roomData:[],
      roomDateRangeValue:[],
      optionType:0,
      tableContainerWith:0,
      dialogOrderVisible:false,
      orderDetailData:[],
      calculateTotalData:[],
      searchCalculate:{ 
        city_sn:0,
        room_sn:1,
        store_sn:1,
        daterangeValue:[]
      },
      tabList:[],
      cityListData:[
         {
          "sn":0,
          "name":"全部区域"
        },
        {
          "sn":1,
          "name":"上海"
        },
        {
          "sn":2,
          "name":"北京"
        },
        {
          "sn":3,
          "name":"深圳"
        }
      ],
      storeListData:[
          {
            "sn":1,
            "name":"全部门店"
         }
      ],
      roomListData:[
        {
          "sn":1,
          "name":"全部会议室"
        }
      ],
        
      currentDate: new Date(),

      isShowFinanceExport:false,

      financeExportDaterangeValue:[],

      table1_tabs:"1",
      progress_width:60,
      table1_data:[],

    };
  },
  methods: {

     intPage(){
      this.getOurTeam();
      this.getConfig();
     },

     getConfig(){
        getConfigStatistics({}).then(response => {
            if (response.code == 200) {
                this.tabList=response.data;

                this.handleTabClick();

            }
          })
          .catch(error => {
            console.log(error);
          })

     },

     handleTable1TabsClick(){

        for(let i in this.myArray01){
          if(this.myArray01[i].type=='table1'){
 
            if(this.table1_tabs=="1"){
              this.myArray01[i].data=this.table1_data;
            }

            if(this.table1_tabs=="2"){
              let item=[];
              for(let ii in this.table1_data){
                if(Number(this.table1_data[ii].value3)<100){
                  item.push(this.table1_data[ii]);
                }
              }
              this.myArray01[i].data=item;
            }

            if(this.table1_tabs=="3"){
             let item=[];
              for(let ii in this.table1_data){
                if(!(Number(this.table1_data[ii].value3)<100)){
                  item.push(this.table1_data[ii]);
                }
              }
              this.myArray01[i].data=item;
            }

          }
        }


        console.log(this.table1_data);



     },

     handleTabClick(){

      if(this.activeName=="t0"){
          this.getIntData();
          this.getRoomDateData();
      }

      if(this.activeName=="t1" || this.activeName=="t2" || this.activeName=="t4"){
         this.getData(); 
      }

  
      if(this.activeName=="t3"){
        
        this.getCData();
        this.searchCalculate.city_sn=0;
        this.searchCalculateTotal(0);

      }

     },

     getIntData(){
        const now = new Date();
        // 本月1号：年、月不变，日期设为1
        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
        // 本月最后一天：月份+1，日期设为0（自动回退）
        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

        // 补零函数：1→01，9→09，10+保持不变（处理月份/日期）
        const addZero = num => num < 10 ? `0${num}` : num;

        // 格式化函数：把Date对象转成 YYYY-MM-DD 格式
        const formatDate = date => {
          const year = date.getFullYear();
          const month = addZero(date.getMonth() + 1); // 月份是0基，需+1再补零
          const day = addZero(date.getDate());
          return `${year}-${month}-${day}`;
        };

        let firstDayF=formatDate(firstDay);
        let lastDayF=formatDate(lastDay);
        this.searchCalculate.daterangeValue=[firstDayF,lastDayF];
        this.financeExportDaterangeValue=[firstDayF,lastDayF];
        this.getRoomsListData();

     },

     getCData(){
        const now = new Date();
        // 本月1号：年、月不变，日期设为1
        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
        // 本月最后一天：月份+1，日期设为0（自动回退）
        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

        // 补零函数：1→01，9→09，10+保持不变（处理月份/日期）
        const addZero = num => num < 10 ? `0${num}` : num;

        // 格式化函数：把Date对象转成 YYYY-MM-DD 格式
        const formatDate = date => {
          const year = date.getFullYear();
          const month = addZero(date.getMonth() + 1); // 月份是0基，需+1再补零
          const day = addZero(date.getDate());
          return `${year}-${month}-${day}`;
        };

        let firstDayF=formatDate(firstDay);
        let lastDayF=formatDate(lastDay);
        this.searchCalculate.daterangeValue=[firstDayF,lastDayF];
 

     },
     

    handleChangePicker(){
      this.getRoomsData();
    },

    handleStoresClick(){
      this.getRoomsData();
    },

    timeFrameSelect(type){
      this.optionType=type;
      this.getRoomsData();
    },

    searchCalculateTotal(type){

      if(type==0){


        this.searchCalculate.room_sn=1;
        this.searchCalculate.store_sn=1;

        this.storeListData=[
          {
              "sn":1,
              "name":"全部门店"
          }
        ]

        this.roomListData=[
          {
            "sn":1,
            "name":"全部会议室"
          }
        ]

        this.getStoresListData(0);

      }

      if(type==1){

        this.roomListData=[
          {
            "sn":1,
            "name":"全部会议室"
          }
        ]
        this.getStoresListData(1);

      }

      if(type==2){
        this.getRoomsListData();
      }

      if(type==3){
        this.getCalculateTotal();
       }


    },
    

    getCalculateTotal(){

      let data={
         search:this.searchCalculate
      };
       getCalculateTotalData(data).then(response => {
          if(response.code == 200) {
            this.calculateTotalData=response.data;
          }
        })
        .catch(error => {
          console.log(error);
        });

    },

 
     getStoresListData(type){
      let data={
          search:this.searchCalculate
      };
      getStores2Data(data).then(response => {
          if(response.code == 200) {
            this.storeListData=response.data;
            if(type==1){
             this.getRoomsListData();
            }else{
              this.getCalculateTotal();
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
     },

     getRoomsListData(){
      let data={
        stores_sn:this.searchCalculate.store_sn
      };
      getRooms2Data(data).then(response => {
          if(response.code == 200) {
            this.roomListData=response.data;
            this.getCalculateTotal();
          }
        })
        .catch(error => {
          console.log(error);
        });
     },

     getRoomsData(){

        if(!Array.isArray(this.roomDateRangeValue)){
          this.getRoomDateData();
          return;
        }

       let data={
          "option":this.optionType,
          "storeSN":this.storeSN,
          "roomDateRangeValue":this.roomDateRangeValue,
       };
       getRooms(data).then(response => {
          if(response.code == 200) {
              this.roomData=response.data; 
              this.optionType=0;
              this.roomDateRangeValue =response.data.roomDateRangeValue; 
              this.tableContainerWith=this.roomData['dateRange'].length * 150;
              console.log(this.tableContainerWith);
          }
        })
        .catch(error => {
          console.log(error);
        });

     },

     getRoomDateData(){

      let data={};
       getRoomDate(data).then(response => {
          if(response.code == 200) {

            this.roomCurDate=response.data;
            this.roomDateRangeValue =response.data["weekRangeValue"];
            this.getStoresData();

          }
        })
        .catch(error => {
          console.log(error);
        });

     },

     getStoresData(type){
      let data={};
      getStores(data).then(response => {
          if(response.code == 200) {
            this.storesData=response.data;
            this.storeSN=this.storesData[0].sn;
            this.getRoomsData();
          }
        })
        .catch(error => {
          console.log(error);
        });
     },

     onStart(){
        this.drag=true;
        this.myArray3=JSON.parse( JSON.stringify(this.myArray1));
        this.myArray4=JSON.parse( JSON.stringify(this.myArray2));
     },

     onEnd() {
      this.drag=false;
      this.loading=true;
       for(let x in this.myArray1){
          let move=true;
          for(let y in this.myArray3){
            if(this.myArray1[x].id==this.myArray3[y].id){
              move=false;
            }
          }
          if(move && this.myArray1[x].type=="funnel"){
            let data=JSON.parse( JSON.stringify(this.myArray1[x].data));
            this.funnelContainer(data);
          }
          if(move && this.myArray1[x].type=="bar"){
            let data=JSON.parse( JSON.stringify(this.myArray1[x].data));
            this.barContainer(data);
          }
          if(move && this.myArray1[x].type=="pie"){
            let data=JSON.parse( JSON.stringify(this.myArray1[x].data));
            this.pieContainer(data);
          }
          if(move && this.myArray1[x].type=="line"){
            let data=JSON.parse( JSON.stringify(this.myArray1[x].data));
            this.lineContainer(data);
          }
          if(move && this.myArray1[x].type=="column"){
            let data=JSON.parse( JSON.stringify(this.myArray1[x].data));
            this.columnContainer(data);
          }

       }

       for(let x1 in this.myArray2){
 
          let move=true;
            for(let y in this.myArray4){
              if(this.myArray2[x1].id==this.myArray4[y].id){
                move=false;
              }
            }
    
  
            if(move && this.myArray1[x1].type=="funnel"){
              let data=JSON.parse( JSON.stringify(this.myArray1[x1].data));
              this.funnelContainer(data);
            }
            if(move && this.myArray1[x1].type=="bar"){
              let data=JSON.parse( JSON.stringify(this.myArray1[x1].data));
              this.barContainer(data);
            }
            if(move && this.myArray1[x1].type=="pie"){
              let data=JSON.parse( JSON.stringify(this.myArray1[x1].data));
              this.pieContainer(data);
            }
            if(move && this.myArray1[x1].type=="line"){
              let data=JSON.parse( JSON.stringify(this.myArray1[x1].data));
              this.lineContainer(data);
            }
            if(move && this.myArray1[x1].type=="column"){
              let data=JSON.parse( JSON.stringify(this.myArray1[x1].data));
              this.columnContainer(data);
            }
       }

      this.loading=false;


     },

     viewInit(){

        for(let i in this.myArray1){
        
          if(this.myArray1[i].type=="stacked"){
        
            let data=JSON.parse( JSON.stringify(this.myArray1[i].data));
            this.stackedColumnPlot(data);
          }
          if(this.myArray1[i].type=="funnel"){
            let data=JSON.parse( JSON.stringify(this.myArray1[i].data));
            this.funnelContainer(data);
          }
          if(this.myArray1[i].type=="bar"){
            let data=JSON.parse( JSON.stringify(this.myArray1[i].data));
            this.barContainer(data);
          }
          if(this.myArray1[i].type=="pie"){
            let data=JSON.parse( JSON.stringify(this.myArray1[i].data));
            this.pieContainer(data);
          }
          if(this.myArray1[i].type=="line"){
            let data=JSON.parse( JSON.stringify(this.myArray1[i].data));
            this.lineContainer(data);
          }
          if(this.myArray1[i].type=="column"){
            let data=JSON.parse( JSON.stringify(this.myArray1[i].data));
            this.columnContainer(data);
          }

        }

        for(let i in this.myArray2){
     
          if(this.myArray2[i].type=="stacked"){
            let data=JSON.parse( JSON.stringify(this.myArray2[i].data));
            this.stackedColumnPlot(data);
          }
          if(this.myArray2[i].type=="funnel"){
            let data=JSON.parse( JSON.stringify(this.myArray2[i].data));
            this.funnelContainer(data);
          }
          if(this.myArray2[i].type=="bar"){
            let data=JSON.parse( JSON.stringify(this.myArray2[i].data));
            this.barContainer(data);
          }
          if(this.myArray2[i].type=="pie"){
            let data=JSON.parse( JSON.stringify(this.myArray2[i].data));
            this.pieContainer(data);
          }
          if(this.myArray2[i].type=="line"){
            let data=JSON.parse( JSON.stringify(this.myArray2[i].data));
            this.lineContainer(data);
          }
          if(this.myArray2[i].type=="column"){
            let data=JSON.parse( JSON.stringify(this.myArray2[i].data));
            this.columnContainer(data);
          }

        }

        for(let i in this.myArray01){
     
          if(this.myArray01[i].type=="stacked"){
            let data=JSON.parse( JSON.stringify(this.myArray01[i].data));
            this.stackedColumnPlot(data);
          }
          if(this.myArray01[i].type=="funnel"){
            let data=JSON.parse( JSON.stringify(this.myArray01[i].data));
            this.funnelContainer(data);
          }
          if(this.myArray01[i].type=="bar"){
            let data=JSON.parse( JSON.stringify(this.myArray01[i].data));
            this.barContainer(data);
          }
          if(this.myArray01[i].type=="pie"){
            let data=JSON.parse( JSON.stringify(this.myArray01[i].data));
            this.pieContainer(data);
          }
          if(this.myArray01[i].type=="line"){
            let data=JSON.parse( JSON.stringify(this.myArray01[i].data));
            this.lineContainer(data);
          }
          if(this.myArray01[i].type=="column"){
            let data=JSON.parse( JSON.stringify(this.myArray01[i].data));
            this.columnContainer(data);
          }

        }

     },

     funnelContainer(container){
        const funnelPlot = new Funnel(container.name, {
            data: container.data,
            xField: container.xField,
            yField: container.yField,
            legend: false,
            conversionTag: false,
          });
          funnelPlot.render();
     },

     funnelContainer2(container){
        const funnelPlot = new Funnel(container.name, {
            data: container.data,
            xField: container.xField,
            yField: container.yField,
            legend: false,
            conversionTag: false,
          });
          funnelPlot.render();
     },

     barContainer(container){
        const bar = new Bar(container.name, {
          data: container.data,
          xField: container.xField,
          yField: container.yField,
          seriesField:container.seriesField,
          legend: {
            position: 'top-left', // top-left 'top', 'bottom', 'middle',
          },

            label: {
            position: 'top',  // 置于条形顶部
            style: {
              fill: '#333',   // 文字颜色
              fontSize: 12,
              fontWeight: 'normal',
              wordWrap: true,      // 开启折行
              wordWrapWidth: 80,   // 折行宽度
              lineHeight: 16,
            },
            // 关键：formatter 里返回说明文字
            formatter: (datum) => {
              // datum 是当前条形的数据对象
              return datum.description;  // 直接返回自定义说明
            },
          },
        });
        bar.render();
     },
     
     pieContainer(container){
        const piePlot = new Pie(container.name, {
        appendPadding: 10,
        data:container.data,
        angleField:container.angleField,
        colorField:container.colorField,
        radius: 1,
        innerRadius: 0.64,
        meta: {
          value: {
            formatter: (v) => `${v}`,
          },
        },
        label: {
          type: 'inner',
          offset: '-50%',
          autoRotate: false,
          style: { textAlign: 'center' },
          formatter: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
        },
        statistic: {
          title: {
            offsetY: -8,
          },
          content: {
            offsetY: -4,
          },
        },
        // 添加 中心统计文本 交互
        interactions: [
          { type: 'element-selected' },
          { type: 'element-active' },
          {
            type: 'pie-statistic-active',
            cfg: {
              start: [
                { trigger: 'element:mouseenter', action: 'pie-statistic:change' },
                { trigger: 'legend-item:mouseenter', action: 'pie-statistic:change' },
              ],
              end: [
                { trigger: 'element:mouseleave', action: 'pie-statistic:reset' },
                { trigger: 'legend-item:mouseleave', action: 'pie-statistic:reset' },
              ],
            },
          },
        ],
      });

      piePlot.render();

     },

     lineContainer(container){
          const line = new Line(container.name, {
          data: container.data,
          xField:container.xField,
          yField:container.yField,
          seriesField:container.seriesField,
          label: {},
          point: {
            size: 5,
            shape: 'diamond',
            style: {
              fill: 'white',
              stroke: '#5B8FF9',
              lineWidth: 2,
            },
          },
          tooltip: { showMarkers: false },
          state: {
            active: {
              style: {
                shadowBlur: 4,
                stroke: '#000',
                fill: 'red',
              },
            },
          },
          interactions: [{ type: 'marker-active' }],
        });

        line.render();
     },

     columnContainer(container){
        const columnPlot = new Column(container.name, {
        data: container.data,
        isStack: container.isStack,
        isGroup: container.isGroup,
        xField:container.xField,
        yField:container.yField,
        seriesField:container.seriesField,
        label: {
          // 可手动配置 label 数据标签位置
          position: 'middle', // 'top', 'bottom', 'middle',
          // 配置样式
          style: {
            fill: '#FFFFFF',
            opacity: 0.6,
          },
          layout: [
            // 柱形图数据标签位置自动调整
            { type: 'interval-adjust-position' },
            // 数据标签防遮挡
            { type: 'interval-hide-overlap' },
            // 数据标签文颜色自动调整
            { type: 'adjust-color' },
          ],
        },
        xAxis: {
          nice: false, 
          label: {
            autoHide: false,
            autoRotate: false,
          },
           tickLine: {
            visible: true, // 显示刻度线
          },
          line: {
            visible: true, // 显示轴线
          },
        },
        scrollbar: {
          x: {
            visible: true,
          },
        },
        meta:container.meta
         
      });

      columnPlot.render();
     },

     stackedColumnPlot(container){
         const stackedColumnPlot = new Column(container.name, {
          data:container.data,
          isGroup: true,
          xField: 'x',
          yField: 'y',
   
          seriesField: 'name',
          /** 设置颜色 */
          //color: ['#1ca9e6', '#f88c24'],
          /** 设置间距 */
          marginRatio: 0.1,
          minColumnWidth: 20,
          maxColumnWidth: 20,
          label: {
            // 可手动配置 label 数据标签位置
            position: 'middle', // 'top', 'middle', 'bottom'
            // 可配置附加的布局方法
            layout: [
              // 柱形图数据标签位置自动调整
              { type: 'interval-adjust-position' },
              // 数据标签防遮挡
              { type: 'interval-hide-overlap' },
              // 数据标签文颜色自动调整
              { type: 'adjust-color' },
            ],
          },
        });

        stackedColumnPlot.render();
     },

     checkType(){
      if(this.dateValue[0]==6){
        this.daterange=true;
      }else{
        this.daterange=false;
        this.getData(0);
      }
     },

     checkTeam(){

      if(this.teamValue!=5){
        this.getData(0);
      }

     },
     
     getData(type=0){
      this.myArray1=[];
      this.myArray2=[];
      this.myArray01=[];
      let data={
          type:type,
          active:this.activeName,
          projectValue:this.projectValue,
          joinTypeValue:this.joinTypeValue,
          ourTeamValue:this.ourTeamValue,
          teamValue:this.teamValue,
          dateValue:this.dateValue,
          daterangeValue:this.daterangeValue
      };
      getStatistics(data).then(response => {
          if (response.code == 200) {
               this.myArray1=JSON.parse( JSON.stringify(response.data.myArrays1));
               this.myArray2=JSON.parse( JSON.stringify(response.data.myArrays2));
               this.myArray01=JSON.parse( JSON.stringify(response.data.myArrays3));
               this.projectData=JSON.parse( JSON.stringify(response.data.projectArray));
               this.statisticsArray1=JSON.parse( JSON.stringify(response.data.statisticsArray1));

                for(let i in this.myArray01){
                  if(this.myArray01[i].type=='table1'){
                    this.table1_data=JSON.parse(JSON.stringify(this.myArray01[i].data));
                  }
                }


               setTimeout(()=>{
                 this.viewInit();
              },1000)
              
          }
        })
        .catch(error => {
          console.log(error);
        })
     },
     
     jump(url,engine,where){


      let daterangeValue1=null;
      let daterangeValue2=null;

        if(this.daterangeValue.length>0){
          daterangeValue1=this.daterangeValue[0];
          daterangeValue2=this.daterangeValue[1];
        }

        this.$router.push({
              path:url,
              query: {
                  whereID:where,
                  engine:engine,
                  teamValue:this.teamValue,
                  ourTeamValue:this.ourTeamValue,
                  joinTypeValue:this.joinTypeValue,
                  dateValue1:this.dateValue[0],
                  dateValue2:this.dateValue[1],
                  daterangeValue1:daterangeValue1,
                  daterangeValue2:daterangeValue2
               }
        });

     },

     getOurTeam(){
      let data={
        "teamValue":1
      }
      ourTeam(data).then(response => {
          if(response.code == 200) {
            this.ourTeam=response.data;
          }
        })
        .catch(error => {
          console.log(error);
        })
     },

     cou(){
      fetch('https://gw.alipayobjects.com/os/antfincdn/8elHX%26irfq/stack-column-data.json')
      .then((data) => data.json())
      .then((data) => {
        const stackedColumnPlot = new Column('container', {
          data,
          isStack: true,
          xField: 'year',
          yField: 'value',
          seriesField: 'type',
          label: {
            // 可手动配置 label 数据标签位置
            position: 'middle', // 'top', 'bottom', 'middle'
            // 可配置附加的布局方法
            layout: [
              // 柱形图数据标签位置自动调整
              { type: 'interval-adjust-position' },
              // 数据标签防遮挡
              { type: 'interval-hide-overlap' },
              // 数据标签文颜色自动调整
              { type: 'adjust-color' },
            ],
          },
        });

        stackedColumnPlot.render();
      });

     },

     getOrderDetai(sn){

      let data={
        "sn":sn
      }
     getOrderDetailData(data).then(response => {
          if(response.code == 200) {

            this.dialogOrderVisible=true;
            this.orderDetailData=response.data;

          }
      })
        .catch(error => {
          console.log(error);
       })

     },

     handleOrderClose(){
      this.dialogOrderVisible=false;
     },

      goToPC(){
        /* 【P199】环境中性化：原实现硬编码 `http://crm.liubai.simpleappeal.cn/#/pc`，
           导致同一份产物在 cs8 上点击会跳到 cs7 生产站点（跨环境串站）。
           改为使用**当前页面同源**（自动带上正确的协议与域名）：
             cs7 → https://crm.liubai.simpleappeal.cn/#/pc
             cs8 → https://liubai.cs8.simpleappeal.cn/#/pc
           同时把 http 改为跟随当前页面协议，避免 https 页面被浏览器按混合内容降级拦截。 */
        var base = (window.location.origin || "").replace(/\/+$/, "");
        window.open(base + "/#/pc", "_blank");
      },

    handleFinanceExport(){
      this.isShowFinanceExport=true;
    },

    handleFinanceExportClose(){
      this.isShowFinanceExport=false;
    }, 


    handleFinanceOrderExport(){

        let data={
            search:{
              daterangeValue:this.financeExportDaterangeValue
            }
        };
       getExportRoomOrder(data).then(response => {
          if (response.code == 200) {
               window.open(response.data);
          }
        })
        .catch(error => {
          console.log(error);
        })

   



    },
  
    handleFinanceContractsExport(){

        let data={
          search:{
            daterangeValue:this.financeExportDaterangeValue
          }
           
        };
       getExportContracts(data).then(response => {
          if (response.code == 200) {
            window.open(response.data);
          }
        })
        .catch(error => {
          console.log(error);
        })

    },


    handleExportTargetShow(){
      this.isShowExportTarget=true;
    },

    handleExportTargetClose(){
      this.isShowExportTarget=false;
    }, 
    
    handleExportTargetData(){

      let data={
          search:{
            daterangeValue:this.targetDaterangeValue
          }
      };
      getExportTarget(data).then(response => {
          if (response.code == 200) {
               window.open(response.data);
          }
        })
        .catch(error => {
          console.log(error);
        })
    },

    exportData(id){
      let data={
          downLoad:id,
          active:this.activeName,
          projectValue:this.projectValue,
          joinTypeValue:this.joinTypeValue,
          ourTeamValue:this.ourTeamValue,
          teamValue:this.teamValue,
          dateValue:this.dateValue,
          daterangeValue:this.daterangeValue
      };
      getStatistics(data).then(response => {
          if (response.code == 200) {
              window.open(response.data);
          }
        })
        .catch(error => {
          console.log(error);
        })
    }


  },
  mounted() {
    this.intPage();
  }
};

</script>




// WEBPACK FOOTER //
// src/pages/title.vue